import { ServiceBase } from '../../../../../core/services/ServiceBase'
import proxy from './proxy'

class Service extends ServiceBase {
  getTransactionStatus(params) {
    return this.getData(() => proxy.getTransactionStatus(params))
  }
  getOrderStatus(params) {
    return this.getData(() => proxy.getOrderStatus(params))
  }
  getListOrders(params) {
    return this.getData(() => proxy.getListOrders(params))
  }
  postNewTransactionOrders(params) {
    return this.getData(() => proxy.postNewTransactionOrders(params), true)
  }
}

const service = new Service()
export default service
